import { formatDate } from "_helper/utils";
import { FORM_ERROR_MESSAGES } from "Constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";

export const useListTableColumns = () => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: "Tên đơn vị",
      selector: ({ ten }) => ten,
    },
    {
      name: "Mô tả",
      selector: ({ moTa }) => moTa || "",
    },
    {
      name: "Loại đơn vị",
      selector: ({ loaiDonVi }) => loaiDonVi,
    },
    {
      name: "Địa chỉ",
      selector: ({ diaChi }) => diaChi,
    },
    {
      name: "Số điện thoại",
      selector: ({ soDienThoai }) => soDienThoai,
    },
    {
      name: "Mã số thuế",
      selector: ({ maSoThue }) => maSoThue,
    },
    {
      name: "Người đại diện",
      selector: ({ nguoiDaiDien }) => nguoiDaiDien,
    },
    {
      name: "Ngày thành lập",
      selector: ({ ngayThanhLap }) => formatDate(ngayThanhLap),
    },
  ];
  return { tableColumns };
};

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  return [
    {
      name: "ten",
      label: "Tên đơn vị",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "moTa",
      label: "Mô tả",
      type: "text",
    },
    {
      name: "loaiDonVi",
      label: "Loại đơn vị",
      type: "select",
      options: [],
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "diaChi",
      label: "Địa chỉ",
      type: "text",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soDienThoai",
      label: "Số điện thoại",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^[0-9]{10,11}$/,
          message: "Số điện thoại không hợp lệ",
        },
      },
    },
    {
      name: "maSoThue",
      label: "Mã số thuế",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^\d{10,13}$/,
          message: "Mã số thuế không hợp lệ",
        },
      },
    },
    {
      name: "nguoiDaiDien",
      label: "Người đại diện",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "ngayThanhLap",
      label: "Ngày thành lập",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
  ].flat() as any;
};

export const title = "Hồ sơ đơn vị";
export const parent = "Quản lý hồ sơ";
